export const limitedArrayField = (columnData, limit) => {
   if (columnData && columnData.length) {
      const columnDataCopy = [...columnData]
      const more = columnDataCopy.length > limit ? ' ...' : ''
      columnDataCopy.length = columnDataCopy.length < limit ? columnDataCopy.length : limit
      return JSON.stringify(columnDataCopy) + more
   } else {
      return null
   }
}